// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__M5LGb","ContactSectionDiv":"Contact_ContactSectionDiv__gGlSh","ContactSection":"Contact_ContactSection__ldWnU","icon":"Contact_icon__qDlQW"};